var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getApiUrl } from "./apiEndPoints";
export var Ptn;
(function (Ptn) {
    const BaseUrl = getApiUrl();
    //============================================================================================================
    //                                     GENERIC GET DATA API CALL
    //                  All other classes uses these methods to get data from the server
    //============================================================================================================
    class DataAccess {
        //============================================================================================================
        //                                     GENERIC GET DATA API CALL
        //============================================================================================================
        static getData(controllerAndMethodUrl) {
            return __awaiter(this, void 0, void 0, function* () {
                const url = `${BaseUrl}${controllerAndMethodUrl}`;
                let apiResponse = {
                    status: 0,
                    message: "",
                    data: {},
                };
                try {
                    const response = yield fetch(url, {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem("token")}`,
                            'Content-Type': 'application/json',
                            'Accept': 'application/json',
                        },
                    });
                    apiResponse.status = response.status;
                    apiResponse.message = response.statusText;
                    if (!response.ok) {
                        return apiResponse;
                    }
                    const data = yield response.json().catch(() => {
                        apiResponse.status = 500;
                        apiResponse.message = "Invalid JSON response";
                        return apiResponse;
                    });
                    apiResponse.data = data;
                    return apiResponse;
                }
                catch (error) {
                    apiResponse.status = 500;
                    if (error instanceof Error) {
                        apiResponse.message = error.message;
                    }
                    else {
                        apiResponse.message = "An unknown error occurred";
                    }
                    return apiResponse;
                }
            });
        }
        //============================================================================================================
        //                                     GENERIC CREATE DATA API CALL
        //============================================================================================================
        static createData(controllerAndMethodUrl, dataModel) {
            return __awaiter(this, void 0, void 0, function* () {
                const url = `${BaseUrl}${controllerAndMethodUrl}`;
                let apiResponse = {
                    status: 0,
                    message: "",
                    data: {},
                };
                try {
                    const response = yield fetch(url, {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${localStorage.getItem("token")}`,
                        },
                        body: JSON.stringify(dataModel),
                    });
                    apiResponse.status = response.status;
                    apiResponse.message = response.statusText;
                    if (!response.ok) {
                        return apiResponse;
                    }
                    const data = yield response.json().catch(() => {
                        apiResponse.status = 500;
                        apiResponse.message = "Invalid JSON response";
                        return apiResponse;
                    });
                    apiResponse.data = data;
                    return apiResponse;
                }
                catch (error) {
                    apiResponse.status = 500;
                    if (error instanceof Error) {
                        apiResponse.message = error.message;
                    }
                    else {
                        apiResponse.message = "An unknown error occurred";
                    }
                    return apiResponse;
                }
            });
        }
        //============================================================================================================
        //                                     GENERIC UPDATE DATA API CALL
        //============================================================================================================
        static updateData(controllerAndMethodUrl, dataModel) {
            return __awaiter(this, void 0, void 0, function* () {
                const url = `${BaseUrl}${controllerAndMethodUrl}`;
                let apiResponse = {
                    status: 0,
                    message: "",
                    data: {},
                };
                try {
                    const response = yield fetch(url, {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${localStorage.getItem("token")}`,
                        },
                        body: JSON.stringify(dataModel),
                    });
                    apiResponse.status = response.status;
                    apiResponse.message = response.statusText;
                    if (!response.ok) {
                        return apiResponse;
                    }
                    const data = yield response.json().catch(() => {
                        apiResponse.status = 500;
                        apiResponse.message = "Invalid JSON response";
                        return apiResponse;
                    });
                    apiResponse.data = data;
                    return apiResponse;
                }
                catch (error) {
                    apiResponse.status = 500;
                    if (error instanceof Error) {
                        apiResponse.message = error.message;
                    }
                    else {
                        apiResponse.message = "An unknown error occurred";
                    }
                    return apiResponse;
                }
            });
        }
        //============================================================================================================
        //                                     GENERIC DELETE DATA API CALL
        //============================================================================================================
        static deleteData(controllerAndMethodUrl, dataModel) {
            return __awaiter(this, void 0, void 0, function* () {
                const url = `${BaseUrl}${controllerAndMethodUrl}`;
                let apiResponse = {
                    status: 0,
                    message: "",
                    data: {},
                };
                try {
                    const response = yield fetch(url, {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${localStorage.getItem("token")}`,
                        },
                        body: JSON.stringify(dataModel),
                    });
                    apiResponse.status = response.status;
                    apiResponse.message = response.statusText;
                    if (!response.ok) {
                        return apiResponse;
                    }
                    const data = yield response.json().catch(() => {
                        apiResponse.status = 500;
                        apiResponse.message = "Invalid JSON response";
                        return apiResponse;
                    });
                    apiResponse.data = data;
                    return apiResponse;
                }
                catch (error) {
                    apiResponse.status = 500;
                    if (error instanceof Error) {
                        apiResponse.message = error.message;
                    }
                    else {
                        apiResponse.message = "An unknown error occurred";
                    }
                    return apiResponse;
                }
            });
        }
    }
    Ptn.DataAccess = DataAccess;
})(Ptn || (Ptn = {}));
export default Ptn.DataAccess;
